import React from 'react';

const seoPortfolioItems = [
  {
    id: 1,
    image: '/assets/images/seo-services/seo-portfolio (1).jpg',
    title: 'Keyword Ranking & Organic Traffic Growth',
    category: 'SEO Strategy & Traffic Surge'
  },
  {
    id: 2,
    image: '/assets/images/seo-services/seo-portfolio (2).jpg',
    title: 'Search Visibility & Performance Audit',
    category: 'Technical SEO & Performance'
  },
  {
    id: 3,
    image: '/assets/images/seo-services/seo-portfolio (3).jpg',
    title: 'SERP Domination & High-Intent Leads',
    category: 'On-Page Optimization'
  },
  {
    id: 4,
    image: '/assets/images/seo-services/seo-portfolio (4).jpg',
    title: 'Revenue Acceleration & Domain Authority',
    category: 'Off-Page Authority Building'
  }
];

function SeoPortfolioSection() {
  const handleConsultationClick = (e) => {
    e.preventDefault();
    const formEl = document.querySelector('.contact-section') || document.getElementById('contact-form');
    if (formEl) {
      formEl.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.location.href = '/contact/';
    }
  };

  return (
    <section className="seo-portfolio-section" id="seo-portfolio">
      <div className="container">
        {/* Section Header */}
        <div className="seo-portfolio-header">
          <div className="seo-portfolio-badge-row">
            <span className="seo-portfolio-badge">Proven Rankings & Impact</span>
            <div className="seo-portfolio-badge-line"></div>
          </div>

          <h2 className="seo-portfolio-title">
            Our Search Engine Optimization <span className="seo-red-title">Portfolio & Results</span>
          </h2>

          <p className="seo-portfolio-subtitle">
            Discover how our targeted search strategies, keyword domination, and data-driven SEO optimizations deliver sustained organic traffic and measurable business growth.
          </p>
        </div>

        {/* 4 Cards Grid - 2x2 Clean Image Showcase */}
        <div className="seo-portfolio-grid">
          {seoPortfolioItems.map((item) => (
            <div
              key={item.id}
              className="seo-portfolio-card"
              onClick={handleConsultationClick}
            >
              <div className="seo-portfolio-img-wrapper">
                <img
                  src={item.image}
                  alt={item.title}
                  className="seo-portfolio-img"
                  loading="lazy"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default SeoPortfolioSection;
